/** @format */
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { OpenUniversityCart } from 'common-typescript/types';
import { CartPaymentType } from '../../constants';

@Component({
    selector: 'app-cart-price',
    templateUrl: './cart-price.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CartPriceComponent {
    @Input() cart: OpenUniversityCart;
    @Input() showOnlySummary?: boolean = false;
    @Input() alignRight?: boolean = false;
    @Input() paymentType?: CartPaymentType;
    @Input() totalCredits?: number;

    readonly zeroPrice = 'EUR 0.00';

    get isStudyVoucherPayment(): boolean {
        return this.paymentType === 'STUDY_VOUCHER_PAYMENT';
    }
}
